import React from 'react';
import PropTypes from 'prop-types';
import SubscriptionDTO from '../../../DTOs/Subscription/SubscriptionDTO';
import DetailPanel from './DetailPanel';
import { USDollar } from '../../../utilities/Constants';
import { formatPhoneNumber } from '../../../utilities/PhoneFormat';

export default function SubscriptionDetailPanel(props) {
    const { row } = props;

    return (
        <DetailPanel
            sections={[
                {
                    title: 'Tenant',
                    fields: [
                        { label: 'Name', value: `${row.appUser.firstName} ${row.appUser.lastName}` },
                        { label: 'Email', value: row.appUser.username },
                        { label: 'Phone', value: formatPhoneNumber(row.appUser.phone) },
                        { label: 'Door code', value: row.appUser.doorCode ?? null },
                        { label: 'Licence', value: row.appUser.driversLicenseNumber },
                    ],
                },
                {
                    title: 'Storage unit',
                    fields: [
                        { label: 'Unit', value: row.storageUnit.name },
                        { label: 'Size', value: row.storageUnit.storageSize },
                        { label: 'Price', value: USDollar.format(row.storageUnit.price) },
                        { label: 'Payment', value: row.paymentOption.name },
                        {
                            label: 'Standing',
                            value: row.inGoodStanding ? 'Good standing' : 'Not in good standing',
                        },
                    ],
                },
            ]}
        />
    );
}

SubscriptionDetailPanel.propTypes = {
    row: PropTypes.objectOf(SubscriptionDTO),
};
